// Locale-aware accessors for the /[lang]/cities hub's hand-written copy. Same
// approach as winePageCopy (wine-content.ts): read off the imported resource
// JSON directly, since `intro` / `faq` are arrays (no `returnObjects` dance
// through t()).

import type { Locale } from '@todo/core/i18n/locales';
import en from '@/lib/i18n/resources/en.json';
import fr from '@/lib/i18n/resources/fr.json';
import ru from '@/lib/i18n/resources/ru.json';

export type CitiesHubFaqEntry = { q: string; a: string };

export type CitiesHubCopy = {
  intro: string[];
  /** One line per city id, shown on its card — what sets the town apart. */
  taglines: Record<string, string>;
  faqHeading: string;
  faq: CitiesHubFaqEntry[];
};

type CitiesHubResource = { citiesHub: CitiesHubCopy };

const resources: Record<Locale, CitiesHubResource> = { en, fr, ru };

export function citiesHubCopy(locale: Locale): CitiesHubCopy {
  return resources[locale].citiesHub;
}
